import React from 'react';

const JavaScriptAppWrapper = () => {
  return (
    <div>
      <iframe
        src="https://niansahc.github.io/self-care-8-ball/"
        title="Self-Care 8-Ball"
        width="100%"
        height="600px"
        style={{ border: "none" }}
      />
    </div>
  );
};

export default JavaScriptAppWrapper;